import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'd-header',
  template: `<div class="d-header-header-content"><ng-content></ng-content></div>
             <button class="d-header-close-button icon-cds icon-cds-close"
                  *ngIf="showClose"
                  (click)="onCancelClicked()"></button>`,
})
export class DialogHeaderHelperComponent {
  @Input() showClose: boolean;
  @Output() cancelClicked: EventEmitter<any> = new EventEmitter<any>();

  onCancelClicked() {
    this.cancelClicked.emit();
  }
}
